<template>
  <div class="column-basic">
    <div class="title-mod"  >
      <el-row :gutter="20" v-if="list">
        <el-col :span="16">
          <div class="text">
            {{list.type_name}}
          </div>
        </el-col>
        <el-col :span="8">
         <div class="am-text-right">
            <router-link class="more" tag="a" :to="'/list/'+list.type_id">
            <img src="../../assets/images/more.png" alt="">
            </router-link>
         </div>
        </el-col>
      </el-row>
       <div class="text" v-if="text">
            {{text}}
          </div>
    </div>

    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list:{
      },
      text:{
        default:''
      }
    }

  }
</script>

<style lang="scss">
  .column-basic {
    margin-bottom: 20px;
    overflow: hidden;
    padding: 0 20px;
    .content {
    }

    .title-mod {
      margin-top: 12px;
height: 32px;
line-height: 32px;
background-image: url(~@/assets/images/circle.png);
background-repeat: repeat-x;
background-position: bottom;
      .text {
        display: inline-block;
        padding: 0 20px;
        color: white;
        border-radius: 20px;
 background-image:  linear-gradient( 0deg, rgb(249,129,13) 0%, rgb(249,149,22) 100%);

      }

      .more {
      }
    }
  }
</style>